<template>
  <v-dialog v-model="dialogOpen" width="550" persistent>
    <v-card>
      <v-card-title>Edit Delivery Address</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <ModemAddressForm :passedAddress="passedAddress"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="deliveryAddressLoading" :loading="deliveryAddressLoading">SAVE</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState,mapActions,mapMutations } from 'vuex';
  import ModemAddressForm from "./ModemAddressForm";
  export default {
    props: ['dialogOpen'],
    components: {ModemAddressForm},
    data() {
      return {
        passedAddress: {
          line_one: '',
          line_two: '',
          city: '',
          county: '',
          post_code: '',
          country: ''
        }
      }
    },
    watch: {
      dialogOpen(val) {
        if(val){
          if(this.telcoModemAddress.post_code!==undefined){ this.passedAddress = this.telcoModemAddress; }
        }
      }
    },
    computed: {
      ...mapState('globals', ['selectedAddress']),
      ...mapState('products',['currentProduct','deliveryAddressLoading','telcoModemAddress']),
    },
    methods: {
      ...mapMutations('products', ['setCurrentProductModemDeliveryAddress']),
      async submit(){
        try{
          this.setCurrentProductModemDeliveryAddress(this.selectedAddress);
          this.closeDialog();
        }catch(err){}
      },
      closeDialog(){ this.$emit('close-dialog'); }
    },
  }
</script>

<style lang="scss" scoped>

</style>
